export { carouselVariables as carouselPaddleVariables } from './carouselVariables';
